











































import VueOptions from '@utils/VueOptions'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'
import { RRule } from 'rrule'

export DEFAULT_WEEKLY_RRULE =
  freq: RRule.WEEKLY
  byweekday: [0, 1, 2, 3, 4, 5, 6]
  interval: 1

settings =
  name: 'WeeklyRuleForm'

  vue:
    props: ['form', 'actions']

    components: {
      FormFieldRadioButton,
    }

    data: ->
      shortcutByWeekDay: null

    mounted: ->
      @syncShortcutByWeekday @form.rrule.byweekday
      @ruleChanged()

    computed:
      weeklyOptions: ->
        [
          { label: 'S', value: RRule.SU.weekday, tooltip: 'Sunday' }
          { label: 'M', value: RRule.MO.weekday, tooltip: 'Monday' }
          { label: 'T', value: RRule.TU.weekday, tooltip: 'Tuesday' }
          { label: 'W', value: RRule.WE.weekday, tooltip: 'Wednesday' }
          { label: 'R', value: RRule.TH.weekday, tooltip: 'Thursday' }
          { label: 'F', value: RRule.FR.weekday, tooltip: 'Friday' }
          { label: 'S', value: RRule.SA.weekday, tooltip: 'Saturday' }
        ]

      optionsForShortcutByWeekDay: ->
        [
          { value: 'everyday', label: 'Everyday', byweekday: [0..6] }
          { value: 'weekdays', label: 'Weekdays', byweekday: [0..4], tooltip: 'Mon - Fri' }
          { value: 'weekends', label: 'Weekends', byweekday: [5, 6], tooltip: 'Sat & Sun' }
        ]

    methods:
      hiSelectShortcutByWeekDay: (value) ->
        { byweekday } = @optionsForShortcutByWeekDay.find((option) -> option.value is value)
        @form.rrule.byweekday = byweekday
        @$emit 'change', @form

      hiByWeekday: (byweekday) ->
        @syncShortcutByWeekday byweekday
        @ruleChanged()

      syncShortcutByWeekday: (byweekday=[]) ->
        byweekdayStr = JSON.stringify([...byweekday].sort())
        option = @optionsForShortcutByWeekDay.find((option) ->
          JSON.stringify([...option.byweekday].sort()) is byweekdayStr
        )
        @shortcutByWeekDay = null
        @shortcutByWeekDay = option?.value

      ruleChanged: ->
        @$emit 'change', @form

export default VueOptions.vue settings
